import request from '@/utils/requestnew'
import baseUrl from '../baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/FrSale'

export default {

    jdSelfPage(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getListPageJdSelf',
            method: 'get',
            params,
        })
    },

    jdPopPage(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getListPageJdPop',
            method: 'get',
            params,
        })
    },

    jdJyPage(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getListPageJdJy',
            method: 'get',
            params,
        })
    },

    tmSelfPage(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getListPageTmSelf',
            method: 'get',
            params,
        })
    },

    tmJyPage(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getListPageTmJy',
            method: 'get',
            params,
        })
    },

}